import {GameCenterIndexPageState} from "./models/game-center.index-page.state";
import {GameCenterIndexPageConfig} from "./game-center.index-page.config";
import {BaseMobxStore} from "../../../../infrastructure/mobx/base-mobx-store";

export class GameCenterIndexPageStore extends BaseMobxStore {
  static injectables = [GameCenterIndexPageConfig, GameCenterIndexPageState];

  state: GameCenterIndexPageState;
}
